export default {
    newDesign: true,
    title: "Odpowiedz na 4 pytania i weź udział w darmowym kursie animacji | Kodland",
    downtimeUrl: "https://www.kodland.org/pl",
    parameters: {
      landing_id: "PlFwdTCl",
      segment: 7,
      success_page: 'pl_thankyou_page_fwd',
    },
    startPage: {
      title:
        "Odpowiedz na tylko 4 pytania i weź udział w BEZPŁATNYM KURSIE tworzenia animacji",
      subtitle:
        "Zajęcia są prowadzone w języku polskim!",
      image: {
        url: "/welcome/fwd_poland_loc_desk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/fwd_poland_loc_mob.png",
        style: {
          width: "100%",
        },
      },
      button: " Ruszajmy 🚀 ",
    },
    stopPage: {
      image: "/welcome/quizV2/no-computer.png",
      title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
      subtitle:
        "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
    },
    quizRotateBySteps: {
      1: {
        question: "Ile czasu dziennie Twoje dziecko spędza używając gadżetów?",
        answers: [
          "😍 Do 2 godzin",
          "🙂 Od 2 do 4 godzin",
          "😔 Więcej niż 4 godziny",
          "🤔 Nie pilnuję tego",
        ],
      },
      2: {
        question: "Jaki charakter ma Twoje dziecko?",
        subtitle: "To pomoże nam odpowiednio dobrać wykwalifikowanego nauczyciela pod charakter Twojego dziecka",
        answers: [
          "🥳 Aktywne, bardzo rozmowne",
          "🫢 Nieśmiałe, często się wstydzi",
          "🥰 Marzycielskie, oddaje się marzeniom",
          "🤫 Ciche, spędza czas 'w sobie'",
          "🤔 Nieśmiałe, często się wstydzi",
          "🙋‍♀️ Własna wersja, opowiem na lekcji"
        ],
      },
      3: {
        question: "Jak oceniasz poziom motywacji Twojego dziecka?",
        answers: [
          "😔 Niski",
          "🤔 Średni",
          "😍 Wysoki"
        ],
      },
      4: {
        title: "Ile lat ma Twoje dziecko?",
        type: "age",
        button: "",
      },
      5: {
        question:
          "Czy masz komputer/laptop?",
        answers: [
          "✔️ Tak",
          {
            answer: "❌ Nie",
            stopAnswer: true,
          },
        ],
      },
      6: {
        title: "Gratulacje!",
        typeInfo: "congrats",
        subtitle:
          "Kliknij '📅 Zarezerwuj zajęcia', aby dokończyć rejestrację.",
        button: "📅 Zarezerwuj zajęcia",
      },
      7: {
        title: "Zarezerwuj zajęcia",
        type: "one-page-contacts",
        subtitle: "",
        button: "👏 Świetnie. Ostatni krok!",
      },
      8: {
        title: "",
        type: "timeslot",
        subtitle: "",
        button: "",
      },
      9: {
        title:
          "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
        typeInfo: "pc-laptop",
        subtitle:
          "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
        button: "Co jeszcze?",
      },
      10: {
        title: "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
        typeInfo: "whatsapp",
        subtitle:
          "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
        button: "Co jeszcze?",
      },
      11: {
        title: "Lekcja odbędzie się na naszej platformie 💻",
        typeInfo: "classroom",
        subtitle:
          "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
        button: "Rozumiem ✅",
      }
    },
  };
  